export const MINIMAX_ANTHROPIC_RAW_MODEL_EVENT_SOURCE =
  'minimax-anthropic-messages';
